// @flow strict

import React from 'react';
import { Link } from '@ansarada/ace-react';
import styles from './styles.scss';

const termsOfUse = 'https://www.ansarada.com/terms-conditions';
const privacyPolicy = 'https://www.ansarada.com/privacy';
const cookiePolicy = 'https://www.ansarada.com/cookie-policy';

const termsAndConditions = (
  <Link href={termsOfUse} target="_blank">
    Terms and Conditions
  </Link>
);

const cookiePolicyLink = (
  <Link href={cookiePolicy} target="_blank">
    Cookie Policy
  </Link>
);

const privacyPolicyLink = (
  <Link href={privacyPolicy} target="_blank">
    Privacy Policy
  </Link>
);

export default function FooterTerms() {
  return (
    <div className={styles.footer}>
      <div className={styles.terms}>
        By creating your profile, you agree to our {termsAndConditions} and that you have read our{' '}
        {cookiePolicyLink} and {privacyPolicyLink}.
      </div>
    </div>
  );
}
